<template>
	<div class="register">
		<v-card class="rounded-lg register-card">
			<div class="content">
				<h2>Registro automático</h2>

				<v-btn
					class="login-button pa-6 my-6 rounded-lg"
					color="white"
					elevation="3"
					:href="loginWithGoogle"
				>
					<img
						class="login-icon"
						src="../../assets/User/login/Google.svg"
						alt="google icon"
					/>
					<span class="google">Registrarme con Google</span>
				</v-btn>

				<v-btn
					class="login-button pa-6 rounded-lg"
					color="#1877F2"
					elevation="3"
					:href="loginWithFacebook"
				>
					<v-img
						class="login-icon"
						src="../../assets/User/login/facebook.png"
						alt="google icon"
					></v-img>
					<span>Registrarme con Facebook</span>
				</v-btn>

				<v-divider class="my-8"></v-divider>

				<h2 class="mt-4">Registro manual</h2>

				<span class="mandatory-hint">* Obligatorios</span>
				<v-form v-model="valid" ref="registerForm">
					<div class="card-row">
						<!-- Email text field -->
						<v-text-field
							v-model="email"
							label="Email*"
							:rules="emailValidator"
							type="email"
						></v-text-field>

						<!-- Usernametext field -->
						<v-text-field
							v-model="username"
							label="Nombre de usuario*"
							:rules="notEmpty"
							type="text"
						></v-text-field>
					</div>
					<v-form ref="passwordForm" v-model="passwordsValid">
						<div class="card-row">
							<!-- Password text field -->
							<!-- Logic to show/hide password after label -->
							<v-text-field
								v-model="password"
								label="Contraseña*"
								:append-icon="
									showPassword ? 'mdi-eye' : 'mdi-eye-off'
								"
								@click:append="showPassword = !showPassword"
								:type="showPassword ? 'text' : 'password'"
								:rules="passwordValidator"
							></v-text-field>

							<!-- Password text field -->
							<!-- Logic to show/hide password after label -->
							<v-text-field
								v-model="repeatPassword"
								label="Repetir Contraseña*"
								:append-icon="
									showPassword ? 'mdi-eye' : 'mdi-eye-off'
								"
								@click:append="showPassword = !showPassword"
								:type="showPassword ? 'text' : 'password'"
								:rules="passwordValidator"
							></v-text-field>
						</div>
					</v-form>

					<!-- Name text field -->
					<v-text-field
						v-model="name"
						label="Nombre*"
						:rules="notEmpty"
					></v-text-field>

					<div class="card-row">
						<!-- Date of birth -->
						<!-- Start date of the race -->
						<v-dialog
							ref="dialogDoB"
							v-model="modalDoB"
							:return-value.sync="dateOfBirth"
							width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<!-- Readonly to only modify the date from the date picker-->
								<v-text-field
									:value="dateOfBirth | formatDate"
									label="Fecha de nacimiento*"
									prepend-icon="mdi-calendar"
									readonly
									v-bind="attrs"
									v-on="on"
									:rules="notEmpty"
								></v-text-field>
							</template>

							<!--Date picker -->
							<v-date-picker
								v-model="dateOfBirth"
								scrollable
								locale="es-ES"
								first-day-of-week="1"
								reactive
								ref="datePicker"
								@change="$refs.dialogDoB.save(dateOfBirth)"
							>
								<v-spacer></v-spacer>
								<v-btn
									text
									color="primary"
									@click="modalDoB = false"
									>Cancel</v-btn
								>
							</v-date-picker>
						</v-dialog>

						<v-select
							:items="genders"
							label="Género"
							v-model="gender"
							:rules="notEmpty"
						></v-select>
					</div>

					<div class="card-row">
						<v-text-field
							v-model="weight"
							label="Peso en kilogramos"
							suffix="kg"
							:rules="[...isNumber, ...isWeight]"
						></v-text-field>

						<v-text-field
							v-model="height"
							label="Altura en centímetros"
							suffix="cm"
							:rules="[...isNumber, ...isHeight]"
						></v-text-field>
					</div>

					<v-file-input
						accept="image/*"
						label="Foto de perfil*"
						:rules="validFile"
						@change="fileUploaded"
					></v-file-input>

					<v-checkbox :rules="accepted">
						<template v-slot:label>
							<span
								>He leído y acepto la

								<a
									href="/politica-privacidad"
									target="_blank"
									@click.stop
									>Política de Privacidad</a
								>
								de CARRERAS KINESIA.</span
							></template
						>
					</v-checkbox>

					<!-- <v-checkbox :rules="accepted" class="checkbox">
						<template v-slot:label>
							<div>
								He leído y acepto los
								<a href="#" target="_blank" @click.stop
									>términos y condiciones</a
								>
								de CARRERAS KINESIA
							</div>
						</template>
					</v-checkbox>-->

					<v-checkbox :rules="accepted" class="checkbox">
						<template v-slot:label>
							<div>
								Autorizo a CARRERAS KINESIA a la publicación de
								mi foto de perfil facilitada en el formulario de
								Registro para su publicación en la Web junto con
								los datos identificativos y deportivos.
							</div>
						</template>
					</v-checkbox>

					<v-card-actions>
						<!-- Login button -->
						<v-btn
							color="accent"
							@click="createAccount"
							:disabled="!valid || !passwordsValid || loading"
							:loading="loading"
							class="rounded-lg"
							elevation="0"
							block
							>Crear cuenta</v-btn
						>
					</v-card-actions>

					<!-- End of form -->
				</v-form>
			</div>

			<div class="privacy-notice">
				<p>
					<b
						>Información básica sobre protección de datos
						(RGPD|LOPD-gdd)
					</b>
					<br /><br />
					Responsable: KINESIA SPORT, S.L<br />
					Finalidad: Gestión y tramitación Registro del Usuario​<br />
					Legitimación: Consentimiento del interesado.​<br />
					Destinatarios: No se cederán datos a terceros, salvo
					obligación legal<br />
					Información Adicional: Puede consultar la información
					adicional y detallada sobre Protección de Datos en nuestra
					“<router-link :to="{ name: 'PoliticaPrivacidad' }"
						>Política de Privacidad</router-link
					>".
				</p>
			</div>
		</v-card>
	</div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import validator from "validator";
export default {
	name: "UserRegistration",
	data() {
		return {
			//Component data
			loading: false,
			modalDoB: false,

			//Form data
			email: "",
			username: "",
			password: "",
			repeatPassword: "",
			showPassword: false,
			name: "",
			dateOfBirth: "",
			gender: "",
			height: "",
			weight: "",
			file: undefined,

			valid: false,
			passwordsValid: false,

			emailValidator: [(v) => validator.isEmail(v) || "Email inválido"],
			passwordValidator: [
				(v) =>
					v.length >= 8 ||
					"La contraseña debe tener al menos 8 carácteres",
				() =>
					this.password === this.repeatPassword ||
					"Las contraseñas no coinciden",
			],
			notEmpty: [(v) => v !== "" || "El campo no puede estar vacío"],
			isNumber: [
				(v) => {
					if (v !== "") {
						return (
							validator.isNumeric(v) ||
							"Este campo solo puede contener números"
						);
					} else {
						return true;
					}
				},
			],
			isWeight: [
				(v) => {
					if (v !== "") {
						return (
							(v <= 350 && v >= 30) ||
							"El valor debe ser un peso en kg"
						);
					} else {
						return true;
					}
				},
			],
			isHeight: [
				(v) => {
					if (v !== "") {
						return (
							v <= 250 ||
							v <= 50 ||
							"El valor debe ser una altura en cm"
						);
					} else {
						return true;
					}
				},
			],
			accepted: [(v) => v || "Debe aceptar para continuar"],
			validFile: [
				(file) =>
					file !== undefined ||
					"La foto de perfil no puede estar vacía",
				(file) => {
					if (file) {
						return (
							file.size < 5 * 1024 * 1024 ||
							"El archivo tiene que pesar menos de 5MB"
						);
					}
					return true;
				},
			],

			//Form extra data
			genders: ["Hombre", "Mujer", "Otros"],
		};
	},
	computed: {
		loginWithGoogle() {
			return `${process.env.VUE_APP_BACK_URL}/api/auth/google`;
		},
		loginWithFacebook() {
			return `${process.env.VUE_APP_BACK_URL}/api/auth/facebook`;
		},
	},
	filters: {
		formatDate(date) {
			if (date === "") {
				return "";
			} else {
				return moment(date).locale("es-ES").format("ll");
			}
		},
	},
	watch: {
		modalDoB(val) {
			val &&
				setTimeout(() => (this.$refs.datePicker.activePicker = "YEAR"));
		},
		password() {
			this.$refs.passwordForm.validate();
		},
		repeatPassword() {
			this.$refs.passwordForm.validate();
		},
	},
	methods: {
		/**
		 * ON file upload
		 */
		fileUploaded(e) {
			this.file = e;
		},

		/**
		 * Creates account
		 * */
		async createAccount() {
			this.loading = true;
			try {
				if (
					this.$refs.registerForm.validate() &&
					this.$refs.passwordForm.validate()
				) {
					const formData = new FormData();
					formData.append("avatar", this.file);
					formData.set("username", this.username);
					formData.set("email", this.email);
					formData.set("password", this.password);
					formData.set("name", this.name);
					formData.set("dateOfBirth", this.dateOfBirth);
					formData.set("gender", this.gender.toLowerCase());
					formData.set("height", this.height);
					formData.set("weight", this.weight);

					await axios.post(
						process.env.VUE_APP_BACK_URL + "/api/users",
						formData,
						{
							headers: {
								"content-type": "multipart/form-data",
							},
						}
					);

					this.$emit("snackbar-event", {
						color: "success",
						text:
							"Se ha enviado un correo electrónico a su dirección de email para verificar su correo.",
					});

					this.$router.push({ name: "UserMain" });
				}
			} catch (error) {
				this.loading = false;
				let errorToDisplay;

				//If there is an array of errors
				if (
					error.response &&
					error.response.data &&
					error.response.data instanceof Array
				) {
					errorToDisplay = "";
					error.response.data.forEach((error) => {
						errorToDisplay += `${error}<br />`;
					});
					//If only one error
				} else if (error.response && error.response.data) {
					errorToDisplay = error.response.data;
					//Rest of the cases
				} else {
					errorToDisplay =
						"Ha ocurrido un error en la creación del usuario, inténtelo de nuevo más tarde";
				}
				this.$emit("snackbar-event", {
					color: "error",
					text: errorToDisplay,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";
.register {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	padding: 2em 1em;

	background-color: #f0f0f3;

	.register-card {
		width: 100%;
		max-width: 600px;
		height: fit-content;

		.content {
			padding: 2em;
			.card-row {
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
				column-gap: 1em;
			}

			.mandatory-hint {
				font-size: 0.8em;
				font-weight: bold;
				color: var(--v-error-base);
			}

			.privacy-notice {
				p {
					text-align: justify;
					font-size: 0.7em;
				}
			}

			.checkbox {
				margin: 0 !important;
			}

			.card-actions {
				padding: 0;
			}

			.new-account {
				margin-top: 1em;

				a {
					color: $accent;
				}
			}
		}

		.privacy-notice {
			background-color: #e6e6ec;
			padding: 2em;
			p {
				text-align: justify;
				font-size: 0.7em;
				margin: 0;
			}
		}
	}
}

.login-button {
	display: flex;
	text-align: center;
	white-space: pre-wrap;

	.v-btn__content {
		width: 100%;
	}

	.login-icon {
		max-height: 24px;
		max-width: 24px;
	}
	span {
		flex: 1;
		color: #fff;
		padding-left: 1em;
		font-size: 1em;

		&.google {
			color: #808080;
		}
	}
}
</style>

<style lang="scss">
.login-button {
	.v-btn__content {
		width: 100% !important;
	}
}
</style>
